export default __webpack_public_path__ + "static/cis-logo-10785bbf60a13774a62d868fd421e60b.png";